import React, { useState } from "react";
import Accueil from "./Accueil";
import Historique from "./Historique";
import Pratiques from "./Pratiques";
import AccederDonnees from "./AccederDonnees";
import Scenarios from "./Scenarios";
import StevensX from "./stevensx.jsx"; // Nom du fichier sur disque

export default function App() {
  const [page, setPage] = useState("accueil");

  // Ajoute le bouton retour sauf sur la page d'accueil
  const renderWithRetour = (Component) => (
    <div style={{ position: "relative" }}>
      <button
        style={{
          position: "absolute",
          top: "1em",
          left: "1em",
          padding: "0.5em 1.2em",
          background: "#464d1bff",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          fontWeight: "bold",
          zIndex: 100
        }}
        onClick={() => setPage("accueil")}
      >
        ← Retour à l’accueil
      </button>
      <Component onNavigate={setPage} />
    </div>
  );

  // Normalise la casse pour la navigation
  const normalizedPage = page.toLowerCase();
  return (
    <>
      {normalizedPage === "accueil" && <Accueil onNavigate={setPage} />}
      {normalizedPage === "dashboard" && <AccederDonnees onNavigate={setPage} />}
      {normalizedPage === "historique" && <Historique onNavigate={setPage} />}
      {normalizedPage === "pratiques" && <Pratiques onNavigate={setPage} />}
      {normalizedPage === "scenarios" && <Scenarios onNavigate={setPage} />}
      {normalizedPage === "stevensx" && <StevensX />}
      {/* Si la page n'est pas reconnue, retourne à l'accueil */}
      {["accueil","dashboard","historique","pratiques","scenarios","stevensx"].indexOf(normalizedPage) === -1 && <Accueil onNavigate={setPage} />}
    </>
  );
}
